import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=38f1493c&"
import script from "./Review.vue?vue&type=script&lang=ts&"
export * from "./Review.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseStarRating: require('/home/vsts/work/1/a/NuxtApp/components/base/StarRating.vue').default})
